/* eslint-disable no-nested-ternary */
/* eslint-disable global-require */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { onNavStyleChange, toggleCollapsedSideNav } from 'appRedux/actions/Setting';
import PropTypes from 'prop-types';
import {
  NAV_STYLE_DRAWER,
  NAV_STYLE_FIXED,
  NAV_STYLE_MINI_SIDEBAR,
  NAV_STYLE_NO_HEADER_MINI_SIDEBAR,
  TAB_SIZE,
  THEME_TYPE_LITE
} from '../../constants/ThemeSetting';

class SidebarLogo extends Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }

  render() {
    const { width, themeType, navCollapsed } = this.props;
    let { navStyle } = this.props;
    if (width < TAB_SIZE && navStyle === NAV_STYLE_FIXED) {
      navStyle = NAV_STYLE_DRAWER;
    }
    return (
      <div className="gx-layout-sider-header">

        {(navStyle === NAV_STYLE_FIXED || navStyle === NAV_STYLE_MINI_SIDEBAR) ? (
          <div className="gx-linebar">

            <i
              className={
                `gx-icon-btn icon icon-${navStyle === NAV_STYLE_MINI_SIDEBAR
                  ? 'menu-unfold'
                  : 'menu-fold'} ${themeType !== THEME_TYPE_LITE ? 'gx-text-white' : ''}`
              }
              onClick={() => {
                if (navStyle === NAV_STYLE_DRAWER) {
                  this.props.toggleCollapsedSideNav(!navCollapsed);
                } else if (navStyle === NAV_STYLE_FIXED) {
                  this.props.onNavStyleChange(NAV_STYLE_MINI_SIDEBAR);
                  this.props.changeCollapsed(true);
                } else if (navStyle === NAV_STYLE_NO_HEADER_MINI_SIDEBAR) {
                  this.props.toggleCollapsedSideNav(!navCollapsed);
                  this.props.changeCollapsed(false);
                } else {
                  this.props.onNavStyleChange(NAV_STYLE_FIXED);
                  this.props.changeCollapsed(false);
                }
              }}
            />
          </div>
        ) : null}

        <Link
          className="gx-site-logo"
          to="/user/home"
        >
          {navStyle === NAV_STYLE_NO_HEADER_MINI_SIDEBAR && width >= TAB_SIZE
            ? <img alt="" src={require('assets/images/w-logo.png')} />
            : themeType === THEME_TYPE_LITE
              ? <img alt="" height="45px" src={require('assets/images/logoQTIdata.png')} />
              : <img alt="" src={require('assets/images/logo.png')} />}
        </Link>

      </div>
    );
  }
}

SidebarLogo.propTypes = {
  width: PropTypes.number.isRequired,
  themeType: PropTypes.string.isRequired,
  navStyle: PropTypes.string.isRequired,
  navCollapsed: PropTypes.bool.isRequired,
  toggleCollapsedSideNav: PropTypes.func.isRequired,
  onNavStyleChange: PropTypes.func.isRequired,
  changeCollapsed: PropTypes.func.isRequired
};

const mapStateToProps = ({ settings }) => {
  const {
    navStyle, themeType, width, navCollapsed
  } = settings;
  return {
    navStyle, themeType, width, navCollapsed
  };
};

export default connect(mapStateToProps, {
  onNavStyleChange,
  toggleCollapsedSideNav
})(SidebarLogo);
